import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";
import { MediumCustomIcon } from "../../layer00";

// Horizontal gutter shared by the panel header, sections and footer. The panel
// is full-screen on mobile, so it gets a roomier gutter there.
export const RIGHT_PANEL_GUTTER = { xs: "1.5rem", sm: "1rem" };

type RightPanelLayoutProps = {
  title: string;
  handleClose: () => void;
  children: ReactNode;
};

export const RightPanelLayout = (props: RightPanelLayoutProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const borderColor = isDark ? theme.palette.divider : "#ECEEF9";

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100vh"
      bgcolor={isDark ? theme.palette.background.paper : "#FFFFFF"}
      borderLeft={{ xs: "none", sm: `1px solid ${borderColor}` }}
      width={{
        xs: "100vw",
        sm: "15rem",
      }}
      sx={{
        overflowY: "auto",
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        columnGap=".5rem"
        flexShrink={0}
        paddingY=".75rem"
        paddingX={RIGHT_PANEL_GUTTER}
        borderBottom={`1px solid ${borderColor}`}
      >
        <Typography
          variant="cardTitle"
          flex="1 1 0"
          minWidth={0}
          noWrap
          sx={{
            color: isDark ? theme.palette.text.primary : "#001F4E",
            fontWeight: 600,
          }}
        >
          {props.title}
        </Typography>
        <IconButton
          onClick={props.handleClose}
          aria-label="Close panel"
          sx={{
            padding: ".25rem",
            marginRight: "-.25rem",
            border: "none",
            borderRadius: ".5rem",
            boxShadow: "none",
          }}
        >
          <MediumCustomIcon
            icon="CLOSE"
            stroke={isDark ? theme.palette.text.secondary : "#53565A"}
          />
        </IconButton>
      </Box>

      {props.children}
    </Box>
  );
};
